import { RouteObject } from 'react-router-dom'
import { mapPlatformRoutesToPaths, extendPath } from '@wellesley/router'
import { MemoizedRemoteApp } from '../../../../features/remote-app/RemoteApp'
import { ToolbarLayout } from '../../../layouts/ToolbarLayout'
import { ErrorBoundaryLayout } from './ErrorBoundaryLayout'
import { ErrorPage } from '@wellesley/error-kit'

const errorRoute = {
  path: '*',
  element: <ErrorPage error={404} />,
}

const devAppRoute = [
  {
    path: '/g/:groupname/*',
    element: (
      <MemoizedRemoteApp
        key="dev"
        id="dev"
        src="http://localhost:3001"
        name="Dev App"
      />
    ),
  },
  {
    path: '*',
    element: (
      <MemoizedRemoteApp
        key="dev"
        id="dev"
        src="http://localhost:3001"
        name="Dev App"
      />
    ),
  },
]

const generateAppRoutes = () =>
  mapPlatformRoutesToPaths()?.map(({ path, url, name, id }) => ({
    path: extendPath(path),
    element: <MemoizedRemoteApp key={url} id={id} name={name} src={url} />,
  })) as RouteObject[] | undefined

export const getAppsRoutes = () => {
  const appRoutesList = generateAppRoutes()

  const appRoutes: RouteObject = {
    element: (
      <ToolbarLayout>
        <ErrorBoundaryLayout />
      </ToolbarLayout>
    ),
    children: appRoutesList ? [...appRoutesList, errorRoute] : devAppRoute,
  }

  return appRoutes
}
